import { render, staticRenderFns } from "./NominasModal.vue?vue&type=template&id=23e66de2&"
import script from "./NominasModal.vue?vue&type=script&lang=js&"
export * from "./NominasModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports